import React, { useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

import './index.scss';

const COLORS = ['#2B0D61', '#ED6E00', '#648F38', '#7E6C9E', '#F2A664', '#b1d78bff'];

const PSInvestmentTabs = ({ dataSets }) => {
  const [activeTab, setActiveTab] = useState('emitter');

  const currentData = dataSets[activeTab];
  const date = new Date();
  const month = date.toLocaleString('es-PE', { month: 'long' });
  const year = date.getFullYear();

  const percentageTotal = () => {
    const total = currentData?.items.reduce((acc, curr) => {
      const valor = parseFloat(curr.porcentajeParticipacion);
      return acc + (Number.isNaN(valor) ? 0 : valor);
    }, 0);

    return parseFloat(total);
  };

  const amountTotal = () => {
    const moneda = currentData?.items[0]?.montoTotal.match(/[A-Z]{3}/)?.[0] || 'USD';

    const totalNumerico = currentData?.items.reduce((acc, curr) => {
      const valorNumerico = parseFloat(curr.montoTotal.replace(/[^\d.,-]/g, '').replace(',', '.'));
      return acc + (Number.isNaN(valorNumerico) ? 0 : valorNumerico);
    }, 0);

    return `${moneda} ${totalNumerico}`;
  };

  return (
    <div className="investment-tabs">
      <div className="investment-tabs__header">
        <h3>¿Cómo se invierte su dinero?</h3>
        <p>
          Actualmente su dinero está invertido en el <strong>Fondo Balanceado</strong>, ideal para
          personas que desean un nivel de riesgo moderado, y así es como nuestro equipo de expertos
          diversifica la inversión para este tipo de fondo:
        </p>
      </div>
      <div className="investment-tabs__menu">
        <button
          type="button"
          className={activeTab === 'emitter' ? 'active' : ''}
          onClick={() => setActiveTab('emitter')}
        >
          Emisores
        </button>
        <button
          type="button"
          className={activeTab === 'economicSector' ? 'active' : ''}
          onClick={() => setActiveTab('economicSector')}
        >
          Sector económico
        </button>
        <button
          type="button"
          className={activeTab === 'instrument' ? 'active' : ''}
          onClick={() => setActiveTab('instrument')}
        >
          Tipo de instrumentos
        </button>
      </div>
      <div className="investment-tabs__content">
        <div className="investment-tabs__chart">
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie
                data={currentData?.items}
                dataKey="porcentajeParticipacion"
                nameKey="nombre"
                innerRadius={70}
                outerRadius={100}
                paddingAngle={3}
                minAngle={3}
                isAnimationActive={false}
              >
                {currentData?.items?.map((entry, index) => (
                  <Cell key={entry.id} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                formatter={(porcentajeParticipacion, nombre) => [
                  `${porcentajeParticipacion}%`,
                  nombre,
                ]}
                contentStyle={{
                  borderRadius: 8,
                  border: '1px solid #ddd',
                  fontSize: 13,
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Tabla */}
        <div className="investment-tabs__table">
          <table>
            <thead>
              <tr>
                <th />
                <th>Inversión</th>
                {/* <th>Monto</th> */}
              </tr>
            </thead>
            <tbody>
              {currentData?.items?.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    <span
                      className="dot"
                      style={{ backgroundColor: COLORS[index % COLORS.length] }}
                    />
                    {item.nombre}
                  </td>
                  <td>{item.porcentajeParticipacion}%</td>
                  {/* <td>{item.montoTotal}</td> */}
                </tr>
              ))}
              <tr className="total-row">
                <td>Total</td>
                <td>{percentageTotal()}%</td>
                {/* <td>{amountTotal()}</td> */}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="investment-tabs__info">
        <div>
          Fuente: Protecta Security actualizada a {month} del {year};
        </div>
      </div>
    </div>
  );
};

export default PSInvestmentTabs;
